import { createAsyncThunk } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

export const getRangPvForAnimal = createAsyncThunk(
  "rangPv/getRangPvForAnimal",
  async ({ animalId, kodaPv, kodaIzracun }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `/api/plemenske_vrednosti/rang/forZival/${animalId}`,
        {
          kodaPv,
          kodaIzracun,
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(getErrorMessage(error));
    }
  }
);
